import { render, staticRenderFns } from "./resourceInitialize.vue?vue&type=template&id=25edea7c&scoped=true"
import script from "./resourceInitialize.vue?vue&type=script&lang=js"
export * from "./resourceInitialize.vue?vue&type=script&lang=js"
import style0 from "./resourceInitialize.vue?vue&type=style&index=0&id=25edea7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25edea7c",
  null
  
)

export default component.exports